module.exports = __webpack_public_path__ + "static/media/admu.d79ebdfb.jpg";